import { Component, input } from '@angular/core';
import { GcTextComponent, IpoTranslatePipe } from '@ip-only/front-end-library';

export interface SpanColorGuideData {
  hexCode: string;
  colorName: string;
  description: string;
}

@Component({
  selector: 'app-span-color-guide',
  imports: [GcTextComponent, IpoTranslatePipe],
  templateUrl: './span-color-guide.component.html',
  styleUrl: './span-color-guide.component.scss',
})
export class SpanColorGuideComponent {
  data = input<SpanColorGuideData[]>();
}
